// extracted by mini-css-extract-plugin
export default {"root":"jPf8eX","arcsContainer":"hPH1gQ","rotation":"XNVqT8","darkArc":"rXryOp","lightArc":"vKobdb","staggered-rotation":"VnP1qs","staggeredRotation":"VnP1qs","text":"jhneaj"};